import {
  IPsrCustomerService,
  IPsrCustomerSettings,
  IPsrCustomerVulnerability,
} from "@/models/psr/psr.types"

export class PsrCustomerSettings implements IPsrCustomerSettings {
  customerServices: Array<IPsrCustomerService>
  customerVulnerabilities: Array<IPsrCustomerVulnerability>

  constructor(
    customerServices: Array<IPsrCustomerService>,
    customerVulnerabilities: Array<IPsrCustomerVulnerability>,
  ) {
    this.customerServices = customerServices
    this.customerVulnerabilities = customerVulnerabilities
  }
}
